import { createSlice } from '@reduxjs/toolkit';
import { getAuthorityStatusList } from './thunk';

const getOptionLabel = item => item?.name || item?.label || item?.description || item?._id || '';

export const initialState = {
    authorityStatusList: [],
    authorityStatusListSelect: [],
    isLoadingList: false,
    isSuccess: false,
};

const AuthorityStatusSlice = createSlice({
    name: 'AuthorityStatus',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getAuthorityStatusList.pending, state => {
            state.isLoadingList = true;
            state.isSuccess = false;
        });
        builder.addCase(getAuthorityStatusList.fulfilled, (state, action) => {
            const list = action.payload || [];
            state.authorityStatusList = list;
            state.authorityStatusListSelect = list.map(item => ({
                item,
                value: item._id,
                label: getOptionLabel(item),
            }));
            state.isLoadingList = false;
            state.isSuccess = true;
        });
        builder.addCase(getAuthorityStatusList.rejected, (state, action) => {
            state.error = action.payload || null;
            state.isLoadingList = false;
            state.isSuccess = false;
        });
    },
});

export default AuthorityStatusSlice.reducer;
